<template>
  <div class='subscribe-container'>
    <div class="qrcode-img-wrapper">
      <img src="../../assets/img/img_qrcode.png">
      <p>长按二维码关注【国花瓷西凤酒官方】服务号</p>
      <p>关注后请重新扫码参与国花瓷活动</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subscribe',
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.subscribe-container {
  width: 100%;
  height: 100%;
  background: #fff;
  .qrcode-img-wrapper {
    padding: 150px 0;
    text-align: center;
    img {
      width: 186px;
      height: 186px;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #747474;
      letter-spacing: -0.35px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/user/subscribe.vue